import {ComponentRef, inject, Injectable, OnDestroy, ViewContainerRef} from "@angular/core";
import {ErrorHandlerService} from "./error-handler.service";
import {filter, Subject, takeUntil} from "rxjs";
import {isDefined} from "../util/isDefined";
import {GlobalErrorToastComponent} from "../../shared/toast/global-error/global-error-toast.component";


/**
 * provides component to provided viewContainerRef
 */
@Injectable({providedIn: "root"})
export class ToastService implements OnDestroy {
    private readonly errorService = inject(ErrorHandlerService);

    private destroy$: Subject<void> = new Subject();
    private viewContainerRef?: ViewContainerRef;
    private toast: ComponentRef<any>;
    private timeOutRef: any;

    constructor() {

        this.errorService.globalError.pipe(

            takeUntil(this.destroy$),
            filter(()=> isDefined(this.viewContainerRef))

        ).subscribe(event=> this.handleToast(GlobalErrorToastComponent, {

            inputs: {
                message: event.exception
            },

            removalTime: 6000 //[ms]

            /*
            onClose: ()=>{} | Signal<any> | Function
            */

        }))

    }

    public provideViewRef(viewRef: any){
        this.viewContainerRef = viewRef;
    }

    private handleToast(component: any, options?: any){

        if(this.toast){ this.removeOldToast(); }

        this.toast = this.viewContainerRef?.createComponent(component);

        //map provided inputs
        for(const [key, value] of Object.entries(options.inputs)){
            (this.toast as ComponentRef<any>).setInput(key,value);
        }

        //provide "onClose" callback to options for customized close event handling
        this.toast.instance.close.subscribe((closeValue: any)=> {
            options?.onclose?.(closeValue);
            this.removeOldToast();
        })

        //remove toast after time has gone through
        if( options.removalTime )  {
            //(async () => this.timeOutRef = setTimeout( this.removeOldToast.bind(this) , options.removalTime ))()
        }

    }

    private removeOldToast(){
        if(this.timeOutRef) { clearTimeout(this.timeOutRef); }
        if(!this.toast){ return; }
        this.viewContainerRef.remove(this.viewContainerRef.indexOf(this.toast.hostView))
        delete this.toast;
    }

    ngOnDestroy() {
        this.destroy$.next();
    }

}